import React, { useEffect, useMemo, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { Nav } from "react-bootstrap";
import { useLocation, Link } from "react-router-dom";
import i18n from 'utils/I18n';


import "./BottomNavigator.scss"
import WechatCookieBar from "../WechatCookieBar";
import { createAction } from "utils";
import { inMiniProgram } from "utils/WeChatUtil";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { mobileDetectIsInMainNav, mobileAttachActiveForMainNav, getCamelCase } from "component/common/navigator/NavigatorUtils";
import { detectIsMobileByScreenWidth } from "utils/ScreenUtils";
import CookieBar from "../CookieBar";

const BottomNavigator = ({
  agreeCookiePolicy,
  recheckCookie,
  language,
}) => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const isInMiniProgram = inMiniProgram();
  const isMobileView = detectIsMobileByScreenWidth();
  const currentPathname = location.pathname;
  const [didButtonClicked, setDidButtonClicked] = useState(false);

  const cookieEnabledRef = useRef();

  const rejectAction = () => {
    setDidButtonClicked(true)
    dispatch(createAction("users/updateState")({ recheckCookie: false }));
  }

  const agreeAction = () => {
    if (navigator.cookieEnabled) {
      dispatch(createAction("users/userAgreeCookiePolicy")({}));
      dispatch(createAction("users/updateState")({ recheckCookie: false }));
      setDidButtonClicked(true)
    }
  }

  const showCookieBar = useMemo(() => {
    if (didButtonClicked) {
      return false
    }
    if (!isInMiniProgram) {
      return false
    }
    return !navigator.cookieEnabled || !agreeCookiePolicy;
  }, [isInMiniProgram, agreeCookiePolicy, didButtonClicked])

  const showNav = useMemo(() => {
    if (!currentPathname) {
      return false
    }
    const mobileShowNav = mobileDetectIsInMainNav(currentPathname)
    return mobileShowNav
  }, [currentPathname])

  const navButtons = useMemo(() => {
    return mobileAttachActiveForMainNav(currentPathname)
  }, [currentPathname])

  useEffect(() => {
    if (recheckCookie) {
      setDidButtonClicked(false)
    }
  }, [recheckCookie])

  useEffect(() => {
    cookieEnabledRef.current = navigator.cookieEnabled && agreeCookiePolicy
  }, [
    agreeCookiePolicy,
  ])

  useEffect(() => {
    if (showCookieBar) {
      document.body.classList.add("maint-no-scroll");
      return () => {
        document.body.classList.remove("maint-no-scroll");
      };
    }
  }, [showCookieBar]);

  useEffect(() => {
    if (isInMiniProgram && !cookieEnabledRef.current) {
      const unblock = history.block(() => {
        if (!cookieEnabledRef.current) {
          dispatch(createAction("users/updateState")({ recheckCookie: true }));
          return false
        }
        return true
      })
      return () => { unblock() }
    }
  }, [isInMiniProgram, history, dispatch])

  if (!isInMiniProgram && !isMobileView) {
    return null
  }

  return (
    <>
      {isInMiniProgram && showCookieBar ?
        <div className="custom-mask" /> : null
      }
      {showNav ? <div className={`blank-nav-space ${isInMiniProgram && (showCookieBar || showNav) ? " we-chat-safe-area" : ""}`} /> : null}
      <div
        className={`fixed-page-bottom-container ${isInMiniProgram && (showCookieBar || showNav) ? "we-chat-safe-area" : ""}`}
      >
        <WechatCookieBar
          rejectAction={rejectAction}
          agreeAction={agreeAction}
          showCookieBar={showCookieBar}
        /> 
        {
          showNav ? <Nav className={"page-bottom-navigator"}>
            {navButtons?.map((item) =>
              <Link
                to={{ pathname: item.linkTo }}
                target={item.external ? "_blank" : '_self'}
                rel="noopener noreferrer"
                className={`nav-item ${item.active ? "active" : ""}`}
              >
                <Nav.Item>
                  <img
                    alt={i18n.t(item.name)}
                    src={item.iconSrc}
                    srcSet={item.iconSrcSet}
                    className={`nav-icon ${item?.customClassName || ""}`}
                  />
                  <div className="caption">{getCamelCase({ name: item.name, language }) || ""}</div>
                </Nav.Item>
              </Link>
            )}
          </Nav> : null
        }
      </div>
    </>
  )
}
const mapStateToProps = (state) => ({
  agreeCookiePolicy: state.users.agreeCookiePolicy,
  recheckCookie: state.users.recheckCookie,
  language: state.users.language,
});

export default connect(mapStateToProps)(BottomNavigator);